/** @ngInject */
export class Controller {
    $onInit () {
        this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/phone-numbers.controller.js